export const globalSettingsProductsDvcsBitbucketRoute = {
	name: 'global-settings-products-dvcs-bitbucket',
	path: '/secure/BitbucketPostInstallApprovalAction.jspa',
};
